import { useEffect } from 'react';
import { useDataManagement } from './RequisitarAPI.ts';

const Personaliza = () => {
  const { customization } = useDataManagement();

  useEffect(() => {
    const fetchCustomization = async () => {
      const response = await customization.list();
      if (response.ok && response.data) {
        const styles = response.data;
        Object.keys(styles).forEach(key => {
          document.documentElement.style.setProperty(`--${key}`, styles[key]);
        });
      }
    };

    fetchCustomization();
  }, [customization]);

  return null;
};

export default Personaliza;